import React, { useState } from 'react'
import { FaqCard } from './faqCard'
import { useThemeContext } from 'contexts/themeContext/hooks'

import './faq.scss'

function Faq({ items, themeProp, icon = false }) {
	const [activeIndex, setActiveIndex] = useState(null)
	const [isAllFaqCardsVisible, setIsAllFaqCardsVisible] = useState(
		items.length <= 5
	)

	const { theme } = useThemeContext()

	function showAllFaqCards(event) {
		event.preventDefault()
		setIsAllFaqCardsVisible(true)
	}

	function handleToggleFaqCard(index) {
		setActiveIndex(activeIndex === index ? null : index)
	}

	return (
		<>
			<dl
				itemScope={true}
				itemType="https://schema.org/FAQPage"
				className={`faq ${themeProp}`}
			>
				{items.slice(0, 5).map((item, index) => (
					<FaqCard
						icon={icon}
						key={item.id}
						item={item}
						handleToggleFaqCard={() => handleToggleFaqCard(index)}
						activeClass={activeIndex === index}
					/>
				))}
				{isAllFaqCardsVisible &&
					items
						.slice(5)
						.map((item, index) => (
							<FaqCard
								icon={icon}
								key={item.id}
								item={item}
								handleToggleFaqCard={() => handleToggleFaqCard(index + 5)}
								activeClass={activeIndex === index + 5}
							/>
						))}
			</dl>
			{!isAllFaqCardsVisible && (
				<a className={`link-view-faqs ${theme}`} onClick={showAllFaqCards}>
					Ver mais
				</a>
			)}
		</>
	)
}

export default Faq
